import { all } from 'axios'
import _ from 'lodash'
import { defineStore } from 'pinia'

export const useNewsStore = defineStore('news', {
	state: () => {
		return {
			articles: [],
			filter: null,
		}
	},
	getters: {
		categories(state) {
			let allCategories = state.articles?.flatMap(({ category }) => category)
			console.log(allCategories)
			let categories = [...new Set(allCategories.map((o) => JSON.stringify(o)))].map((string) => JSON.parse(string))
			console.log(categories)
			return _.orderBy(categories, 'name')
		},
		filtered(state) {
			return state.filter
				? state.articles.filter(function (a) {
						return a.category.slug == state.filter
					})
				: state.articles
		},
	},
	actions: {
		setup() {
			this.getArticles()
		},
		setFilter(slug) {
			this.filter = slug != this.filter ? slug : null
		},
		getArticles() {
			return axios
				.get('/api/news')
				.then((articles) => {
					this.articles = articles.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
	},
})
